import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e90b65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "isOpacity" }
const _hoisted_2 = {
  key: 3,
  class: "transparency"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorSketch = _resolveComponent("ColorSketch")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: _ctx.placement,
    width: _ctx.popoverWidth,
    trigger: _ctx.trigger,
    "popper-class": 'laiiva-global-el-popver',
    "show-arrow": false,
    onBeforeEnter: _cache[2] || (_cache[2] = ($event: any) => {_ctx.sketchShow = true;_ctx.$emit('before-enter')}),
    onHide: _cache[3] || (_cache[3] = ($event: any) => {_ctx.sketchShow = false;_ctx.$emit('hide')}),
    onShow: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('show'))),
    onAfterEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('after-enter'))),
    onBeforeLeave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('before-leave'))),
    onAfterLeave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('after-leave'))),
    teleported: _ctx.teleported
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("div", {
          class: "popover-click-btn",
          style: _normalizeStyle(_ctx.styleInfo)
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.activeTab === _ctx.ColorType.Color)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "current-color",
                  style: _normalizeStyle({
                backgroundColor:
                  _ctx.myColors === 'rgba(255, 255, 255, 0)' ? '' : _ctx.myColors,
              })
                }, null, 4))
              : _createCommentVNode("", true),
            (_ctx.activeTab === _ctx.ColorType.GradientColor)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "current-color",
                  style: _normalizeStyle({ backgroundImage: _ctx.gradientColorStr })
                }, null, 4))
              : _createCommentVNode("", true),
            (_ctx.activeTab === _ctx.ColorType.Image)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  style: _normalizeStyle({ background: `url(${_ctx.pictureUrl ? 'https://resources.laihua.com/' + _ctx.pictureUrl : ''})` }),
                  class: "current-color"
                }, null, 4))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : _createCommentVNode("", true)
          ])
        ], 4)
      ], true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ColorSketch, _mergeProps(_ctx.$attrs, {
        color: _ctx.color,
        sketchShow: _ctx.sketchShow,
        pictureUrl: _ctx.pictureUrl,
        "onUpdate:color": _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.$emit('update:color', $event);
        _ctx.upColor($event);
      }),
        selectType: _ctx.selectType,
        "onUpdate:selectType": _cache[1] || (_cache[1] = ($event: any) => {
        _ctx.$emit('update:selectType', $event);
        _ctx.activeTab = $event;
      }),
        ref: "colorSonRef"
      }), null, 16, ["color", "sketchShow", "pictureUrl", "selectType"])
    ]),
    _: 3
  }, 8, ["placement", "width", "trigger", "teleported"]))
}